export class ApptProtocolModel {
    appt_proc_id: number;
    appt_proc_code: string;
    appt_proc_name: string;
    appt_doctor_slots: number;
    appt_room_slots: number;
    addl_doctor_slots: number;
    addl_room_slots: number;
    appt_max: number;
    appt_resource: string;
    appt_code1: string;
    appt_code2: string;
    appt_code3: string;

    constructor(
        appt_proc_id: number,
        appt_proc_code: string,
        appt_proc_name: string,
        appt_doctor_slots: number,
        appt_room_slots: number,
        addl_doctor_slots: number,
        addl_room_slots: number,
        appt_max: number,
        appt_resource: string,
        appt_code1: string,
        appt_code2: string,
        appt_code3: string
    ) {
        this.appt_proc_id = appt_proc_id;
        this.appt_proc_code = appt_proc_code;
        this.appt_proc_name = appt_proc_name;
        this.appt_doctor_slots = appt_doctor_slots;
        this.appt_room_slots = appt_room_slots;
        this.addl_doctor_slots = addl_doctor_slots;
        this.addl_room_slots = addl_room_slots;
        this.appt_max = appt_max;
        this.appt_resource = appt_resource;
        this.appt_code1 = appt_code1;
        this.appt_code2 = appt_code2;
        this.appt_code3 = appt_code3;
    }
}